<div style="background-color: #F5F7F8; height: 100vh; overflow-y: scroll; padding-top: 10px;">
    <img style="width: 22px; height: 22px; position: absolute; top: 35px; left: 20px;" (click)="this.back()" src="/assets/images/shared/back.svg">
    <h1 style="font-weight: bold; text-align: center; font-size: 16px;">Контакти</h1>
    <div style="background-color: white; padding: 10px; border-radius: 10px; width: 90%; margin: auto; margin-top: 30px;" >
        <div (click)="this.QOexpanded = !this.QOexpanded" style="margin-top: 7px;" data-bs-toggle="collapse" href="#QO" role="button" aria-expanded="false" aria-controls="collapseExample">
            <p style="display: inline-block; font-weight: 700; position: relative; top: 3px;">{{ this.pageDetails().QO }}</p>
            <img [style]="this.arrowStyle(this.QOexpanded)" src="/assets/images/account/right-arrow.svg" alt="">
        </div>
        <div class="collapse" id="QO"><p style="margin-top: 10px; color: #ADAFBB; font-size: 12px;">{{ this.pageDetails().QOinfo }}</p></div>
    </div>

    <div style="background-color: white; padding: 10px; border-radius: 10px; width: 90%; margin: auto; margin-top: 20px;" >
        <div (click)="this.QAExpanded = !this.QAExpanded" style="margin-top: 7px;" data-bs-toggle="collapse" href="#QA" role="button" aria-expanded="false" aria-controls="collapseExample">
            <p style="display: inline-block; font-weight:700; position: relative; top: 3px;">{{ this.pageDetails().QA }}</p>
            <img [style]="this.arrowStyle(this.QAExpanded)" src="/assets/images/account/right-arrow.svg" alt="">
        </div>
        <div class="collapse" id="QA">
            <p style="margin-top: 10px; color: #ADAFBB; font-size: 12px;"> {{ this.pageDetails().QAinfo }}</p>
            <div (click)="this.openEmail()" style="margin-top: 10px;">
                <img style="width: 44px; height: 44px" src="/assets/images/account/icon-email.svg" alt="">
                <p style="display: inline-block; width: 60%; margin-left: 30px; font-weight: bold;"> {{ this.mail }}</p>
            </div>
            <div (click)="this.openTel()" style="margin-top: 10px;">
                <img style="width: 44px; height: 44px" src="/assets/images/account/icon-phone.svg" alt="">
                <p style="display: inline-block; width: 60%; margin-left: 30px; font-weight: bold;"> {{ this.tel }}</p>
            </div>
        </div>
    </div>
</div>

